// <s-sticky-buy> shows a fixed buy bar once the main Add to cart button scrolls out of view
// (above the viewport). Its buttons submit the main product form via the form attribute,
// so the chosen variant and quantity are always the ones sent.
class SStickyBuy extends HTMLElement {
  connectedCallback() {
    this.target = document.querySelector(this.dataset.watch);
    if (!this.target || !('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggle(scrolledPast);
    });
    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  toggle(show) {
    this.toggleAttribute('data-visible', show);
    this.inert = !show;
    this.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
